import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SXIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SX" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#2E42A5"
          fillRule="evenodd"
          d="M0 6v6h16V6H0Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0-1v14l10-7L0-1Z"
        clipRule="evenodd"
      />
      <Mask
        id="c"
        width={10}
        height={14}
        x={0}
        y={-1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0-1v14l10-7L0-1Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#c)">
        <Path
          fill="#FBCD17"
          fillRule="evenodd"
          d="M4.063 4.594c.718 0 1.3-.357 1.3-.797 0-.44-.582-.797-1.3-.797-.718 0-1.3.357-1.3.797 0 .44.582.797 1.3.797Z"
          clipRule="evenodd"
        />
        <Path
          fill="#DA610A"
          d="M4.62 3.443H4.61c-.027 0-.027 0-.074.003-.08.004-.155.012-.217.022l.021.017c.384-.057.564-.057.76-.022l.043.008a.64.64 0 0 0 .122.012h.069c.006 0 .006.001.048.015l.064.076-.062.145-.02.009c-.03.006-.031.006-.037.006a11.816 11.816 0 0 0-.82.093l-.025.032c-.03.021-.048.026-.118.037a4.963 4.963 0 0 1-.427.046c-.24.01-.168.014-.184-.112-.011-.094-.05-.106.033-.128a.925.925 0 0 1-.09-.08c-.049-.05-.058-.054-.053-.055-.003 0-.007.002-.048.017a.58.58 0 0 1-.327.017c-.199-.038-.427 0-.685.12l-.106-.226c.303-.14.583-.189.838-.14a.336.336 0 0 0 .195-.006.445.445 0 0 1 .091-.028c.095-.016.172.024.274.127.118.12.17.134.177.155a.126.126 0 0 0-.004-.027.184.184 0 0 1-.061-.143.2.2 0 0 1 .01-.058v-.011c0-.103.075-.171.181-.171h.443v.25Zm-.65.474.024-.005.023-.005-.048.01Z"
        />
        <Path
          fill="#56C6F5"
          stroke="#E31D1C"
          strokeWidth={0.5}
          d="M4.043 4.29c.496-.08.823-.072 1.013-.008.219.073.461.05.716-.035-.081.36-.124.7-.124 1.02 0 .362.07.656.133.913.065.262.12.476.12.722 0 .215-.071.329-.171.4-.116.081-.308.133-.594.133-.403 0-.78.108-1.128.32l-.005-.003-.006.003a2.127 2.127 0 0 0-1.127-.32c-.285 0-.479-.052-.594-.134-.1-.07-.171-.184-.171-.4 0-.245.054-.46.119-.72.064-.258.135-.552.135-.915 0-.32-.045-.66-.126-1.02.255.087.497.11.716.036.19-.064.517-.073 1.013.009l.041.006.04-.006Z"
        />
        <Path
          fill="#F7FCFF"
          d="M4.392 5.112H4.25v.18l.628.391v.914h.143v.172h-2v-.172h.114v-.914l.6-.374v-.197H3.62l.385-.343.386.343Z"
        />
        <Path
          fill="#FBCD17"
          d="M3.976 8.51c.53 0 .896-.058 1.084-.156a.253.253 0 0 1 .228-.128c.413.015.733-.159.984-.542.272-.413.327-1 .15-1.771l.45-.103c.203.883.136 1.595-.214 2.128-.314.477-.742.732-1.264.75-.266.197-.734.284-1.418.284-.662 0-1.153-.129-1.468-.402-.715-.169-1.169-.454-1.348-.877-.19-.45-.19-1.076-.012-1.881l.45.099c-.159.72-.159 1.257-.013 1.603.102.241.399.438.9.574l.467.1-.022.118c.227.133.575.204 1.046.204Z"
        />
        <Path
          stroke="#73BE4A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
          d="m2.357 4.412.256.103-.128.266.357-.185-.027.137-.077.377.147-.43v.38l.09-.38.265.08-.266-.164.266-.081"
        />
        <Path
          fill="#FBCD17"
          fillRule="evenodd"
          d="M2.844 4.969a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          d="M5.212 4.385c.086 0 .102.385.106.553.15.044.266.172.27.177h-.735s.112-.127.26-.175c.002-.166.014-.555.1-.555Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
